import { render, staticRenderFns } from "./FormReportRegion.vue?vue&type=template&id=3a51b754&scoped=true"
import script from "./FormReportRegion.vue?vue&type=script&lang=js"
export * from "./FormReportRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51b754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a51b754')) {
      api.createRecord('3a51b754', component.options)
    } else {
      api.reload('3a51b754', component.options)
    }
    module.hot.accept("./FormReportRegion.vue?vue&type=template&id=3a51b754&scoped=true", function () {
      api.rerender('3a51b754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/FormReportRegion.vue"
export default component.exports